import { useContext } from "react";
import { DialogContext } from "../providers/DialogProvider";

export function useDialog() {
  return useContext(DialogContext);
}
